module.exports = __webpack_public_path__ + "Roboto-Bold.ab96cca26751239828b8.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/rujuta/Desktop/Projects/agiletimes-master/node_modules/roboto-fontface/fonts/roboto/Roboto-Bold.woff2
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-Bold.woff2
// module chunks = styles